import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import infoImg from "../../assets/images/info.svg";
import profileImg from "../../assets/images/profile.svg";
import "./developer-console.scss";

function navItems(basePath) {
  return [
  {
    to: basePath,
    end: true,
    label: "Dashboard",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9,22 9,12 15,12 15,22" />
      </svg>
    ),
  },
  {
    to: `${basePath}/games`,
    label: "Games",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2" />
        <path d="M18 12h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2" />
        <rect width="12" height="12" x="6" y="8" rx="2" />
      </svg>
    ),
  },
  {
    to: `${basePath}/reports`,
    label: "Reports",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" />
      </svg>
    ),
  },
];
}

function DeveloperLayout({
  children,
  userAvatar,
  creditsBalance,
  onCreateGame,
  onLogout,
  basePath = "/developer",
  viewingAs = null,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const breadcrumbLabel = (() => {
    if (location.pathname.startsWith(`${basePath}/games`)) return "GAMES";
    if (location.pathname.startsWith(`${basePath}/reports`)) return "REPORTS";
    return "DASHBOARD";
  })();
  const items = navItems(basePath);

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dev-console">
      <div
        className={`dev-sidebar-backdrop ${sidebarOpen ? "dev-sidebar-backdrop--visible" : ""}`}
        onClick={closeSidebar}
        aria-hidden="true"
      />

      <aside className={`dev-sidebar ${sidebarOpen ? "dev-sidebar--open" : ""}`}>
        <div className="dev-sidebar-brand">
          <img src={infoImg} alt="Immersely" />
          <span>IMMERSELY</span>
        </div>

        <nav className="dev-sidebar-nav" aria-label="Developer navigation">
          <div className="dev-nav-section">
            <div className="dev-nav-label">PROJECT</div>
            {items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `dev-nav-link ${isActive ? "dev-nav-link--active" : ""}`
                }
                onClick={closeSidebar}
              >
                {item.icon}
                {item.label}
              </NavLink>
            ))}
          </div>

          <div className="dev-nav-section">
            <div className="dev-nav-label">ACCOUNT</div>
            <button
              type="button"
              className="dev-nav-link"
              onClick={() => {
                closeSidebar();
                navigate("/settings");
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
              Settings
            </button>
          </div>
        </nav>

        <div className="dev-sidebar-cta">
          <button type="button" className="dev-btn dev-btn--primary" style={{ width: "100%" }} onClick={onCreateGame}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Create Game
          </button>
        </div>
      </aside>

      <div className="dev-main">
        <header className="dev-topbar">
          <div className="dev-topbar-left">
            <button
              type="button"
              className="dev-menu-toggle"
              onClick={() => setSidebarOpen((prev) => !prev)}
              aria-label="Toggle navigation"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
            <div className="dev-breadcrumbs">
              IMMERSELY // <span>{breadcrumbLabel}</span>
            </div>
          </div>

          <div className="dev-topbar-actions">
            {creditsBalance != null && (
              <div className="dev-credits-chip" title="Credits on your Immersely account">
                <span>Credits</span>
                <strong>{Number(creditsBalance).toLocaleString()}</strong>
              </div>
            )}
            <button type="button" className="dev-btn dev-btn--primary dev-btn--sm" onClick={onCreateGame}>
              Create Game
            </button>
            <div className="dev-avatar-wrap">
              <button type="button" className="dev-avatar-btn" aria-label="Account menu">
                <img
                  src={userAvatar || profileImg}
                  alt=""
                  onError={(e) => {
                    e.target.src = profileImg;
                  }}
                />
              </button>
              <div className="dev-avatar-menu">
                <button
                  type="button"
                  className="dev-avatar-menu-item"
                  onClick={() => navigate("/settings")}
                >
                  Settings
                </button>
                <button type="button" className="dev-avatar-menu-item" onClick={onLogout}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        {viewingAs && (
          <div className="dev-admin-banner" role="status">
            <span>Viewing {viewingAs} as admin. Actions here apply to this studio.</span>
            <button type="button" className="dev-btn dev-btn--ghost dev-btn--sm" onClick={() => navigate("/admin")}>
              Back to admin
            </button>
          </div>
        )}
        <main className="dev-page">{children}</main>
      </div>
    </div>
  );
}

export default DeveloperLayout;
